import {VALIDATIONS} from "../../utils/constants";
import {optionValues, todayEndOfDay} from "../../utils/utils";

export const getFormFields = (formData, states, t, tv) => {
    let step1Fields = [
        { type: "text", name: "firstName", label: "First name", isRequired: true, maxLength: 35, valid: VALIDATIONS.String.isName },
        { type: "text", name: "lastName", label: "Last name", isRequired: true, maxLength: 35, valid: VALIDATIONS.String.isName },
        { type: "text", name: "applicationHealthPlanId", label: "Customer ID (Found on your healthcare ID card)", maxLength: 16 },
        { type: "text", name: "address", label: "Physical address", isRequired: true, maxLength: 35 },
        { type: "text", name: "address2", label: "Physical address line 2", maxLength: 35 },
        { type: "text", name: "city", label: "City", isRequired: true, maxLength: 50 },
        { type: "options", name: "state", label: "State", optionValues: optionValues(states, !formData.state || formData.state === ''), isRequired: true, maxLength: 2, minLength: 2 },
        { type: "number", name: "postalCode", label: "Zip code", isRequired: true, minLength: 5, maxLength: 9, valid: VALIDATIONS.Number.isZipCode },
        { type: "date", name: "birthday", label: "Date of birth", isRequired: true, maxValue: todayEndOfDay() },
        { type: "tel", name: "phone", label: "Phone", isRequired: true, maxLength: 10 },
    ];

    let step2Fields = [];

    return {
        step1Fields,
        step2Fields
    }
}
